<style>
.v-datatable .v-input--selection-controls {
    margin-top: 12px;
}

.v-input--selection-controls.v-input .v-label {
    font-size: 13px;
    /* background-color: #1976D2;
    color: rgba(255, 255, 255, 1); */
}

.flexcard {
    display: flex;
    flex-direction: column;
}
</style>
<template>
    <v-container fluid class="pa-0" id="reservation--view">
        <v-row class="secondary pt-4">
            <v-container fluid style="max-width: 960px;">
                <v-row no-gutters dense>
                    <v-col cols="12" md="4" class="px-1">
                        <v-select solo flat persistent-hint :items="establishments" v-model="selectedEstablishment"
                                  :label="$t('Sportoviště')" :hint="$t('Sportoviště')" single-line menu-props="bottom"
                                  item-text="establishmentName" item-value="establishmentId"
                                  :no-data-text="$t('Nemáme k pronájmu žádnou zónu')"></v-select>
                    </v-col>
                    <v-col cols="12" md="4" class="px-1">
                        <v-select solo flat persistent-hint :items="validCards" v-model="selectedCardId"
                                  :hint="$t('Karta')" menu-props="bottom" item-value="cardId"
                                  :no-data-text="$t('Nemáme k pronájmu žádnou kartu')">
                            <template slot="selection" slot-scope="data">
                                <v-row dense>
                                    <v-col class="text-left" v-if="data.item.displayedCardNo">{{ data.item.displayedCardNo }}</v-col>
                                    <v-col class="text-left">{{ data.item.mainRate.name }}</v-col>
                                </v-row>
                            </template>
                            <template slot="item" slot-scope="data">
                                <v-row dense>
                                    <v-col class="text-left" v-if="data.item.displayedCardNo">{{ data.item.displayedCardNo }}</v-col>
                                    <v-col class="text-left">{{ data.item.mainRate.name }}</v-col>
                                </v-row>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="10" md="3" class="px-1">
                        <v-dialog ref="dialog" persistent v-model="picker" width="290px"
                                  :return-value.sync="currentDate">
                            <template v-slot:activator="{ on }">
                                <v-text-field solo flat persistent-hint :hint="$t('Datum')" v-on="on" label
                                              v-model="formatedCurrentDate" prepend-icon="event"
                                              readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="currentDate" :first-day-of-week="1" locale="cs" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click.native="picker = false">{{ $t('Zrušit') }}</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(currentDate)">{{
                                    $t('OK')
                                    }}
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="2" md="1" class="text-right px-1">
                        <v-select solo flat persistent-hint :items="availableDays" v-model="days"
                                  :hint="$t('Dní')" menu-props="bottom"></v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>
        <v-container fluid style="max-width: 960px;">
            <v-row dense v-if="uniqueLessons.length">
                <v-col cols="12" class="caption" grey--text xs="12">{{ $t('Filtr pro oblíbené') }}
                </v-col>
                <v-chip-group v-model="favLessons" column multiple>
                    <v-menu :close-on-content-click="false" bottom offset-y :disabled="!isFavorited(item)"
                            :open-on-hover="isFavorited(item)" max-width="500" v-for="item in uniqueLessons"
                            :key="item">
                        <template v-slot:activator="{ on }">
                            <v-chip filter color="primary" v-on="on" :key="item" :value="item">{{ item }}</v-chip>
                        </template>
                        <v-card>
                            <v-card-title class="body-2">
                                {{ item }}
                            </v-card-title>
                            <v-data-table :headers="lessonHeaders" :items="lessonItems(item)" hide-default-footer>
                                <template v-slot:item="{ item }">
                                    <tr :style="{ 'background': getHeader(item.activity, item.area).background }"
                                        :active="item.selected" @click="item.selected = !item.selected">
                                        <td>{{ item.area.date | moment('ddd, D.M.YYYY') }}</td>
                                        <td>{{ item.activity.reservation.validFrom | moment('H:mm') }} -
                                            {{ item.activity.reservation.validTo | moment('H:mm') }}
                                        </td>
                                        <td class="hidden-xs-only">{{ item.area.areaName }}</td>
                                        <td><a color="primary" text
                                               @click.stop="toggleReservation(item.activity, item.area)">{{
                                            isPending(item.activity, item.area) ? $t('Odstranit z košíku') : (item.activity.reservation.canRemoveBookingCards.some(isSelected) ? $t('Odlásit') : $t('Rezervovat'))
                                            }}</a>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-menu>
                </v-chip-group>
            </v-row>
            <v-row class="pt-3">
                <v-col class="text-right">
                    <v-btn text color="primary" v-on:click="previous">
                        <v-icon left>fa-arrow-circle-left</v-icon>
                        {{ $t('Předchozí') }}
                    </v-btn>
                </v-col>
                <v-col class="text-left">
                    <v-btn text color="primary" v-on:click="next">{{ $t('Následující') }}
                        <v-icon right>fa-arrow-circle-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
<!--                <v-col cols="12" v-if="!hasCards">-->
<!--                    <v-progress-linear color="primary" indeterminate></v-progress-linear>-->
<!--                </v-col>-->
                <v-col cols="12" v-if="hasActivities">
                    <div id="snippet--calendar" v-for="(scheduledDay, day) in scheduledData" :key="day">
                        <div class="calendar">
                            <v-row class="calendar-wrapper" no-gutters>
                                <v-col cols="12" class="calendar-content" xs="12">
                                    <div class="calendar-row" v-if="day === 0 || scheduledDay.length > 1">
                                        <div class="calendar-heading background: primary">
                                            <div class="calendar-place background: primary">{{
                                                scheduledDay.length > 1 ? formatedDate(scheduledDay[0]['date']) : scheduledDay[0].areaName
                                                }}
                                            </div>
                                            <div class="calendar-timeslots">
                                                <div class="item" v-for="hour in 24" :key="hour">
                                                    <div class="hour-text">{{ hour - 1 }}</div>
                                                </div>
                                            </div>
                                            <!-- <div class="clearfix"></div> -->
                                        </div>
                                    </div>
                                    <div class="calendar-row" v-for="(area, row) in scheduledDay" :key="row">
                                        <div class="calendar-place">{{
                                            scheduledDay.length === 1 ? formatedDate(scheduledDay[0]['date']) : area.areaName
                                            }}
                                        </div>
                                        <div class="calendar-timeslots">
                                            <div class="item" v-for="(activity, item) in area.activities" :key="item"
                                                 :style="{ width: activityWidth(activity) + '%' }">
                                                <div :style="timeslotStyle(activity, area)" class="item-timeslot"
                                                     @click.stop="cardByItem = day*10000+row*100+item">
                                                    <v-card class="item-card flexcard" :style="cardStyle(activity)"
                                                            elevation="10" width="280" height="360"
                                                            v-show="canSelect(activity, area) && cardByItem === day*10000+row*100+item"
                                                            @click.stop="onMouseLeave"
                                                            @mouseleave="onMouseLeave">
                                                        <v-card-title
                                                                :style="{ 'background': getHeader(activity, area).background }">
                                                            <v-row dense class="text-center">
                                                                <v-col cols="12" class="title">
                                                                    {{ getHeader(activity, area).title }}
                                                                </v-col>
                                                                <v-col cols="12" mb-2 class="body-1">{{
                                                                    area.areaName
                                                                    }}
                                                                </v-col>
                                                                <v-col cols="12" class="body-2"
                                                                       v-if="activity.reservation && activity.reservation.reservationInfoText">
                                                                    {{ activity.reservation.reservationInfoText }}
                                                                </v-col>
                                                                <v-col cols="12" class="body-2"
                                                                       v-else-if="activity.reservation && activity.reservation.activityName">
                                                                    {{ activity.reservation.activityName }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-title>
                                                        <v-card-text class="text-center">
                                                            <v-row dense>
                                                                <v-col cols="12" class="body-2">{{
                                                                    $t('Datum: ')
                                                                    }}{{ area.date | moment('ddd, D.M.YYYY') }}
                                                                </v-col>
                                                                <v-col cols="12" class="body-2">{{
                                                                    $t('Čas: ')
                                                                    }}{{ activity.validFrom | moment('H:mm') }} -
                                                                    {{ activity.validTo | moment('H:mm') }}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row dense v-if="activity.reservation">
                                                                <v-col cols="12" class="body-2"
                                                                       v-if="activity.reservation.instructorName">{{
                                                                    $t('Instruktor: ')
                                                                    }}{{ activity.reservation.instructorName }}
                                                                </v-col>
                                                                <v-col cols="12" class="body-2"
                                                                       v-if="activity.reservation.cardLimit && activity.reservation.bookedCount">
                                                                    {{
                                                                    $t('Volná kapacita: ')
                                                                    }}{{
                                                                    activity.reservation.cardLimit - activity.reservation.bookedCount
                                                                    }} z
                                                                    {{ activity.reservation.cardLimit }}
                                                                </v-col>
                                                                <v-col cols="12" class="body-2"
                                                                       v-if="activity.reservation.entryPrice">{{
                                                                    $t('Vstup: ')
                                                                    }}{{ activity.reservation.entryPrice | currency }}
                                                                </v-col>
                                                                <v-col cols="12" class="body-2"
                                                                       v-if="!activity.reservation.entryPrice && activity.reservation.price">
                                                                    {{
                                                                    $t('Cena: ')
                                                                    }}{{ activity.reservation.price | currency }}
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                        <v-card-actions v-if="getHeader(activity, area).canSelect">
                                                            <v-col cols="12" class="text-center">
                                                                <v-btn color="primary"
                                                                       @click="toggleReservation(activity, area)">
                                                                    {{
                                                                    isPending(activity, area) ? $t('Odstranit z košíku') : (activity.reservation.canRemoveBookingCards.some(isSelected) ? $t('Odhlásit') : $t('Rezervovat'))
                                                                    }}
                                                                </v-btn>
                                                            </v-col>
                                                        </v-card-actions>
                                                    </v-card>
                                                </div>
                                            </div>
                                            <!-- <div class="clearfix"></div> -->
                                        </div>
                                        <!-- <div class="clearfix"></div> -->
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <v-col cols="12" class="help text-center" xs="12">
                        <div class="item caption" v-for="(header, index) in usedHeaders" :key="index">
                            <span :style="{ 'background': header.background }"></span>{{ header.title }}
                        </div>
                    </v-col>
                </v-col>
                <v-col cols="12" xs="12" v-if="loading">
                    <v-progress-linear color="primary" indeterminate></v-progress-linear>
                </v-col>
                <v-col cols="12" xs="12" mt-5 v-else>
                    <v-alert :value="!hasActivities" color="info" icon="warning">
                        {{ $t('Pro vybranou zónu a datum nelze rezervovat') }}
                    </v-alert>
                </v-col>
            </v-row>
        </v-container>
        <!--    <v-row class="background: grey lighten-1">-->
        <!--        <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
        <!--          <v-alert type="info" color="grey lighten-1" class="ma-0">-->
        <!--        <div>-->
        <!--          <p>{{ $t('Zde si můžete rezervovat místo. Svoje rezervace si můžete prohlédnout ') }}-->
        <!--            <router-link to="customer?selected=reservations">{{ $t('zde') }}</router-link>-->
        <!--            {{ $t(', karty si můžete prohlédnout ') }}-->
        <!--            <router-link to="customer?selected=cards">{{ $t('zde') }}</router-link>-->
        <!--            {{ $t('.') }}-->
        <!--          </p>-->
        <!--        </div>-->
        <!--          </v-alert>-->
        <!--        </v-container>-->
        <!--    </v-row>-->
    </v-container>
</template>

<script>
import colors from 'vuetify/lib/util/colors'
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

const moment = require('moment')
moment.locale('cs')

export default {
    name: 'ReservationPage',
    mixins: [BasketMixin, CustomerMixin, TransformMixin],
    components: {},
    data() {
        return {
            cardByItem: null,
            selectedEstablishment: null,
            picker: false,
            currentDate: moment(new Date()).format('YYYY-MM-DD'),
            establishments: [],
            scheduledData: [],
            days: 7,
            selectedCardId: null,
            availableDays: [1, 4, 7, 10],
            hover: false,
            reservations: [],
            uniqueLessons: [],
            favLessons: [],
            storedLessons: [],
            loading: false,
            lessonHeaders: [{
                text: 'Datum',
                value: 'area.date',
                sortable: false
            },
                {
                    text: 'Čas',
                    value: 'duration',
                    sortable: false
                },
                {
                    text: 'Místo',
                    value: 'area.areaName',
                    sortable: false
                },
                {
                    text: 'Stav',
                    value: 'status',
                    sortable: false
                }
            ],
            headers: {
                closed: {
                    title: this.transform('Zavřeno'),
                    background: colors.grey.darken2,
                    canSelect: false,
                    isLesson: false
                },
                expired: {
                    title: this.transform('Prošlý vstup'),
                    background: colors.grey.lighten2,
                    canSelect: false,
                    isLesson: false
                },
                notVisibleLesson: {
                    title: this.transform('Odfiltrovaný vstup'),
                    background: colors.grey.lighten3,
                    canSelect: false,
                    isLesson: true
                },
                prohibited: {
                    title: this.transform('Rezervovaný vstup'),
                    background: colors.orange.lighten2,
                    canSelect: false,
                    isLesson: false
                },
                expiredLesson: {
                    title: this.transform('Prošlá rezervace'),
                    background: colors.red.lighten4,
                    canSelect: false,
                    isLesson: true
                },
                notAccessibleLesson: {
                    title: this.transform('Nepřístupný vstup'),
                    background: colors.red.darken1,
                    canSelect: false,
                    isLesson: true
                },
                notReservable: {
                    title: this.transform('Volný vstup'),
                    background: colors.green.lighten4,
                    canSelect: false,
                    isLesson: false
                },
                signedLesson: {
                    title: this.transform('Přihlášená rezervace'),
                    background: colors.yellow.base,
                    canSelect: true,
                    isLesson: true
                },
                freeLesson: {
                    title: this.transform('Přístupný vstup'),
                    background: colors.green.lighten2,
                    canSelect: true,
                    isLesson: true
                },
                pendingLesson: {
                    title: this.transform('V košíku'),
                    background: colors.lightBlue.lighten3,
                    canSelect: true,
                    isLesson: true
                }
            }
        }
    },
    beforeMount() {
        if (this.$oauth2.storage.hasValue('chip-res-days', this.institutionId, this.customerId)) {
            this.days = Number(this.$oauth2.storage.getValue('chip-res-days', this.institutionId, this.customerId))
            if (isNaN(this.days)) {
                this.days = 7
            }
        }
        let dt = moment(this.$route.query.date, 'YYYY-MM-DD', true).isValid() ? this.$route.query.date : null
        if (!dt && this.$oauth2.storage.hasValue('chip-res-date', this.institutionId, this.customerId)) {
            const lsdt = this.$oauth2.storage.getValue('chip-res-date', this.institutionId, this.customerId)
            if (moment(lsdt).isAfter(moment())) {
                dt = lsdt
            }
        }
        if (!dt && this.lastBooking && moment(this.lastBooking.sample.validFrom).isAfter(moment())) {
            dt = moment(this.lastBooking.sample.validFrom).format('YYYY-MM-DD')
        }
        if (moment(dt, 'YYYY-MM-DD', true).isValid()) {
            this.currentDate = dt
        }
        if (this.$oauth2.storage.hasValue('chip-res-card', this.institutionId, this.customerId)) {
            this.selectedCardId = this.$oauth2.storage.getValue('chip-res-card', this.institutionId, this.customerId)
        }
        this.loading = true
        this.$fetch('my/institutions/establishments?customer_accessible=true&reservable=true').then(data => {
            this.establishments = data
            if (this.establishments !== null) {
                let eid = this.$route.query.establishment
                if (!eid && this.$oauth2.storage.hasValue('chip-res-est', this.institutionId, this.customerId)) {
                    eid = this.$oauth2.storage.getValue('chip-res-est', this.institutionId, this.customerId)
                }
                if (!eid && this.lastBooking) {
                    eid = this.lastBooking.sample.reservation.establishment.establishmentId
                }
                if (eid) {
                    let est = this.establishments.find((e) => e.establishmentId === Math.trunc(eid))
                    if (est) {
                        this.selectedEstablishment = est.establishmentId
                    }
                }
                if (!this.selectedEstablishment && this.establishments.length > 0) {
                    this.selectedEstablishment = this.establishments[0].establishmentId
                }
            }
        }).catch(() => console.log('reservable establishments error')).finally(() => this.loading = false)
    },
    mounted() {
        if (this.validCards.length > 0 && (!this.selectedCardId || !this.validCards.some(c => c.card_id === this.selectedCardId))) {
            this.selectedCardId = this.validCards[0].cardId
        }
    },
    computed: {
        canGetData: {
            get() {
                return this.selectedEstablishment && this.currentDate !== null && this.selectedCardId && this.days !== null
            }
        },
        usedHeaders: {
            get() {
                var headers = []
                this.scheduledData.forEach(data => data.forEach(day => day.activities.forEach(a => {
                    const h = this.getHeader(a, day)
                    if (!headers.includes(h)) {
                        headers.push(h)
                    }
                })))
                return headers
            }
        },
        hasActivities: {
            get() {
                return this.scheduledData.length !== 0
                // return this.scheduledData.length !== 0 ? this.scheduledData.find(it => it.activities.length !== 0) : false
            }
        },
        formatedCurrentDate: {
            get() {
                return moment(this.currentDate).format('ddd, D.M.YYYY')
            }
        },
        hasReservableEstablishment: {
            get() {
                return this.establishments !== null && this.establishments.length > 0
            }
        },
        isToday: {
            get() {
                const now = moment()
                const dt = moment(this.currentDate)
                return now.year() === dt.year() && now.dayOfYear() === dt.dayOfYear()
            }
        },
        dates: {
            get() {
                var dates = []
                for (var i = 0; i < this.days; i++) {
                    dates.push(moment(this.currentDate).add(i, 'days').format('YYYY-MM-DD'))
                }
                return dates
            }
        },
        allLessons: {
            get() {
                var lessons = []
                this.scheduledData.forEach(sd => sd.forEach(d => {
                    d.activities.forEach(a => {
                        if (a.isReserved && !this.isExpired(a) && !a.isClosed && this.canReserved(a)) {
                            lessons.push({
                                activity: a,
                                area: d
                            })
                        }
                    })
                }))
                return lessons
            }
        },
        pendingLessons: {
            get() {
                var lessons = []
                this.allLessons.forEach(l => {
                    if (this.isPending(l.activity, l.area)) {
                        lessons.push(this.lessonDesc(l.activity, l.area))
                    }
                })
                return lessons
            },
            set() {
            }
        },
        signedLessons: {
            get() {
                var lessons = []
                this.allLessons.forEach(l => {
                    if (l.activity.isReserved &&
                        ((l.activity.reservation.canRemoveBookingCards.some(this.isSelected) && !this.isPending(l.activity, l.area)) ||
                            (l.activity.reservation.canAddBookingCards.some(this.isSelected) && this.isPending(l.activity, l.area)))) {
                        lessons.push(this.lessonDesc(l.activity, l.area))
                    }
                })
                return lessons
            }
        }
    },
    methods: {
        onMouseLeave() {
          this.cardByItem = null
        },
        isFavorited(value) {
            return this.favLessons.some(l => l === value)
        },
        isUnfavorited(value) {
            return this.storedLessons.some(l => l === value)
        },
        lessonColor(lessons) {
            return lessons.some(l => this.isPending(l.activity, l.area)) ? this.headers.pendingLesson.background : (lessons.some(l => l.activity.reservation.canRemoveBookingCards.some(this.isSelected)) ? this.headers.signedLesson.background : this.headers
                .freeLesson.background)
        },
        timeslotStyle(activity, area) {
            var items = []
            items.push('background: ' + this.getHeader(activity, area).background)
            items.push('cursor: ' + (this.getHeader(activity, area).canSelect ? 'pointer' : 'default'))
            items.push('width: ' + this.activityWidth(activity) + '%')
            return items.join(';')
        },
        cardStyle(value) {
            var items = []
            const from = moment(value.validFrom)
            items.push('bottom: 310px')
            items.push('left: ' + (from.hour() < 16 ? 10 : -270) + 'px')
            return items.join(';')
        },
        lessonItems(value) {
            return this.allLessons.filter(m => this.lessonName(m.activity, m.area) === value)
        },
        formatedDate(value) {
            return moment(value).format('ddd, DD.MM.YYYY')
        },
        shortFormatedDate(value) {
            return moment(value).format('DD.MM.YYYY')
        },
        getData() {
            this.scheduledData = []
            this.loading = true
            this.$fetch('my/institutions/establishments/' + this.selectedEstablishment + '/occupancies/' + moment(this.currentDate).format('YYYY-MM-DD') + '?days=' + this.days)
                .then(data => {
                    if (data) {
                        this.dates.forEach(d => {
                            this.scheduledData.push(data.filter(a => a.date === d))
                        })
                    }
                    this.uniqueLessons = Array.from(new Set(this.allLessons.map(m => this.lessonName(m.activity, m.area)))).filter(n => n)
                    // this.displayedLessons = this.uniqueLessons
                }).catch(() => console.log('occupancy establishments error')).finally(() => this.loading = false)
        },
        // previousDay nastavi datum na vcerejsek
        previous() {
            this.currentDate = moment(this.currentDate).subtract(this.days, 'd').format('YYYY-MM-DD')
        },
        // nextDay nastavi datum na zitrek
        next() {
            this.currentDate = moment(this.currentDate).add(this.days, 'd').format('YYYY-MM-DD')
        },
        // spocita kolik minut trva aktivita s ignorovanim zmeny letniho casu
        activityWidth(value) {
            const from = moment(value.validFrom)
            const to = from.day() === moment(value.validTo).day() ? moment(value.validTo) : moment(value.validFrom).endOf('day')
            const dst = to.isDST() * 60 - from.isDST() * 60
            const duration = Math.round(moment.duration(to.diff(from)).asMinutes()) + dst
            return 100 * duration / (24 * 60)
        },
        lessonName(activity, area) {
            var names = []
            if (activity.reservation.reservationInfoText) {
                names.push(activity.reservation.reservationInfoText)
            } else if (activity.reservation.activityName) {
                names.push(activity.reservation.activityName)
            } else if (activity.reservation.reservationName && activity.reservation.reservationName !== '.') {
                names.push(activity.reservation.reservationName)
            } else if (area) {
                names.push(area.areaName)
            } else {
                names.push('Rezervace')
            }
            if (activity.reservation.instructorName) {
                names.push('- ' + activity.reservation.instructorName + '')
            }
            return names.join(' ')
        },
        lessonDesc(activity, area) {
            return area.areaName + ': ' + moment(activity.reservation.validFrom).format('D.M.YYYY (H:mm') + '-' + moment(activity.reservation.validTo).format('H:mm)')
        },
        // aktivita v kosiku
        pendingItem(activity, area) {
            const ar = activity.reservation ? activity.reservation : {}
            return this.reservationItems.find(r =>
                r.reservation.reservationId === ar.reservationId && r.reservation.time === ar.validFrom &&
                r.reservation.to === ar.validTo && r.reservation.areaId === area.areaId &&
                r.reservation.cardId === this.selectedCardId)
        },
        isPending(activity, area) {
            return this.pendingItem(activity, area) !== undefined
        },
        isExpired(activity) {
            return moment().isAfter(moment(activity.validTo))
        },
        isDisplayed(activity, area) {
            // return this.displayedLessons && this.displayedLessons.includes(this.lessonName(activity, area))
            return this.favLessons.includes(this.lessonName(activity, area))
        },
        getHeader(activity, area) {
            var h = null
            if (this.isPending(activity, area)) {
                h = this.headers.pendingLesson
            } else if (activity.isClosed) {
                h = this.headers.closed
            } else if (this.isExpired(activity)) {
                h = activity.reservation ? this.headers.expiredLesson : this.headers.expired
            } else if (activity.isReserved) {
                if (activity.reservation.canAddBookingCards.some(this.isSelected) || activity.reservation.canRemoveBookingCards.some(this.isSelected)) {
                    if (!this.isDisplayed(activity, area)) {
                        h = this.headers.notVisibleLesson
                    } else if (activity.reservation.cardLimit === 0) {
                        h = this.headers.notAccessibleLesson
                    } else if (activity.reservation.canAddBookingCards.some(this.isSelected)) {
                        h = this.headers.freeLesson
                    } else if (activity.reservation.canRemoveBookingCards.some(this.isSelected)) {
                        h = this.headers.signedLesson
                    }
                } else {
                    h = this.headers.notAccessibleLesson
                }
            } else if (activity.isReservableOnly) {
                h = this.headers.prohibited
            } else {
                h = this.headers.notReservable
            }
            return h
        },
        canReserved(activity) {
            return activity.isReserved && (activity.reservation.canAddBookingCards.some(this.isSelected) || activity.reservation.canRemoveBookingCards.some(this.isSelected))
        },
        isSelected(value) {
            return value === this.selectedCardId
        },
        toggleReservation(activity, area) {
            const item = this.pendingItem(activity, area)
            if (item !== undefined) {
                this.removeItem(item)
            } else {
                const array = []
                const reservation = activity.reservation
                array.push({
                    type: 'reservation',
                    areaId: area.areaId,
                    establishmentId: reservation.establishmentId,
                    time: reservation.validFrom,
                    to: reservation.validTo,
                    itemId: 1,
                    removeFlag: reservation.canRemoveBookingCards.some(this.isSelected),
                    reservationId: reservation.reservationId,
                    itemNo: reservation.itemNo,
                    cardId: this.selectedCardId
                })
                this.putReservations(array)
            }
        },
        canSelect(activity, area) {
          return this.getHeader(activity, area).canSelect
        }
    },
    watch: {
        selectedEstablishment(value) {
            if (value) {
                this.$oauth2.storage.setValue('chip-res-est', this.selectedEstablishment, this.institutionId, this.customerId)
            }
            if (this.canGetData) {
                this.getData()
            }
        },
        currentDate(value) {
            if (value) {
                this.$oauth2.storage.setValue('chip-res-date', this.currentDate, this.institutionId, this.customerId)
            }
            if (this.canGetData) {
                this.getData()
            }
        },
        selectedCardId(value) {
            if (value) {
                this.$oauth2.storage.setValue('chip-res-card', this.selectedCardId, this.institutionId, this.customerId)
            }
            if (this.canGetData) {
                this.getData()
            }
        },
        days(value) {
            if (value) {
                this.$oauth2.storage.setValue('chip-res-days', this.days, this.institutionId, this.customerId)
            }
            if (this.canGetData) {
                this.getData()
            }
        },
        hasValidCards(value) {
            if (value && this.validCards.length > 0 && (!this.selectedCardId || !this.validCards.some(c => c.card_id === this.selectedCardId))) {
                this.selectedCardId = this.validCards[0].cardId
            }
        },
        uniqueLessons(value) {
            this.storedLessons = this.$oauth2.storage.hasValue('chip-res-unfav', this.institutionId, this.customerId) ? this.$oauth2.storage.getValue('chip-res-unfav', this.institutionId, this.customerId).split(',') : []
            this.favLessons = value.filter(l => !this.storedLessons.includes(l))
        },
        favLessons() {
            const deleted = this.uniqueLessons.filter(l => this.isFavorited(l)).filter(l => this.isUnfavorited(l))
            const added = this.uniqueLessons.filter(l => !this.isFavorited(l)).filter(l => !this.isUnfavorited(l))
            if (deleted.length > 0 || added.length > 0) {
                this.storedLessons = this.storedLessons.filter(l => !deleted.includes(l)).concat(added)
                this.$oauth2.storage.setValue('chip-res-unfav', this.storedLessons, this.institutionId, this.customerId)
            }
        }
    }
}
</script>
